<script>
/**
 * tab组件
 * tab组件由tabnav和tabpane构成
 * 调用sj-tab时根据数据构建tabnav
 * sj-tab的slot为传入的tabpane
 */
import TabNav from "./TabNav";

export default {
  name: "SjTab",
  props: {
    value: {},
    beforeLeave: Function,
    type: {
      type: String,
      default: "card",
      validator(v) {
        return ["card", "page", "chrome"].indexOf(v) !== -1;
      }
    },
    size: {
      type: String,
      default: "small",
      validator(v) {
        return ["middle", "small"].indexOf(v) !== -1;
      }
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      panes: [],
      currentName: null
    };
  },
  components: {
    TabNav
  },
  /**
   * render函数取出该组件的props渲染header
   * 使用default slot作为body
   */
  render() {
    const {
      type,
      size,
      editable,
      panes,
      handleTabClick,
      handleCloseClick
    } = this;
    const navData = {
      props: {
        type,
        size,
        editable,
        panes,
        onTabClick: handleTabClick,
        onCloseClick: handleCloseClick
      },
      ref: "nav"
    };

    const header = (
      <div class={["sj-tab-header"]}>
        {type !== "page" && this.$slots.before}
        <TabNav {...navData} />
        {type !== "page" && this.$slots.after}
      </div>
    );
    // const panels = <div class={["sj-tab-content"]}>{this.$slots.default}</div>;
    const panels = this.$slots.default;
    return (
      <div
        class={{
          "sj-tab": true,
          [`sj-tab--${type}`]: true,
          [`sj-tab--${type}-${size}`]: true
        }}
      >
        {[header, panels]}
      </div>
    );
  },
  mounted() {
    /**
     * 自动选择一个标签
     */
    this.$nextTick(() => {
      if (!this.value) {
        this.setCurrentName(this.panes[0]?.name);
      } else {
        this.setCurrentName(this.value);
      }
    });
  },
  methods: {
    /**
     * tab点击响应方法
     */
    handleTabClick(tab, tabName, event) {
      if (tab.disabled) return;
      this.setCurrentName(tabName);
      this.$emit("tab-click", tab, event);
    },
    handleCloseClick(tabName, index, event) {
      this.$emit("tab-close", tabName, index, event);
    },
    /**
     * 增删tab页面，弃用
     */
    addPanes(item) {
      const index = this.$slots.default.indexOf(item.$vnode);
      this.panes.splice(index, 0, item);
    },
    removePanes(item) {
      const panes = this.panes;
      const index = panes.indexOf(item);
      if (index > -1) {
        panes.splice(index, 1);
      }
    },
    setCurrentName(value) {
      const changeCurrentName = () => {
        this.currentName = value;
        console.log("change");
        this.$emit("input", value);
      };
      if (this.currentName !== value && this.beforeLeave) {
        const before = this.beforeLeave(value, this.currentName);
        if (before && before.then) {
          before.then(() => {
            changeCurrentName();
            // this.$refs.nav && this.$refs.nav.removeFocus();
          });
        } else if (before !== false) {
          changeCurrentName();
        }
      } else {
        changeCurrentName();
      }
    },
    refresh() {
      this.panes = this.panes.slice();
    }
  },
  watch: {
    value(val) {
      if (this.currentName !== val) {
        this.setCurrentName(val);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "./index";
@--tab-header-chrome-background-color: @tab-header-chrome-background-color;

@--tab-header-border: @--border-width-base @--border-style-base
  @--tab-border-color;

.sj-tab {
  display: flex;
  flex-direction: column;

  .sj-tab-header {
    flex-shrink: 0;
    position: relative;
    display: flex;
    justify-content: space-between;

    & > div {
      flex-shrink: 0;
    }
  }

  /*.sj-tab-content {*/
  /*flex: 1;*/
  /*min-height: 0;*/
  /*overflow: auto;*/
  /*}*/
}
.sj-tab--card {
  .sj-tab-header {
    border-bottom: @--tab-header-border;

    > div {
      margin-bottom: -1px;
    }
  }
}
.sj-tab--chrome {
  .sj-tab-header {
    background-color: @--tab-header-chrome-background-color;
  }
}
</style>
